import { Navigate, useParams } from 'react-router-dom';

export function LegacyNewsDetailRedirect() {
    const { newsId } = useParams();
    return (
        <Navigate to={`/news/${encodeURIComponent(newsId)}`} replace />
    );
}

export function LegacyProjectDetailRedirect() {
    const { projectId } = useParams();
    return (
        <Navigate
            to={`/projects/${encodeURIComponent(projectId)}`}
            replace
        />
    );
}

export function LegacyMemberDetailRedirect() {
    const { memberId } = useParams();
    return (
        <Navigate
            to={`/member-area/members/${encodeURIComponent(memberId)}`}
            replace
        />
    );
}

export function LegacyGalleryDetailRedirect() {
    const { gallerySlug } = useParams();
    return (
        <Navigate
            to={`/member-area/galleries/${encodeURIComponent(gallerySlug)}`}
            replace
        />
    );
}

const UYE_ALANI_SECTION_TO_PATH = {
    bultenler: '/member-area/bulletins',
    uyeler: '/member-area/members',
    'etkinlik-takvimi': '/member-area/event-calendar',
    galeriler: '/member-area/galleries',
    'ocakbasi-gruplari': '/member-area/fellowship-groups',
};

export function LegacyMemberAreaSectionRedirect() {
    const { section } = useParams();
    const target = UYE_ALANI_SECTION_TO_PATH[section];
    if (target) {
        return <Navigate to={target} replace />;
    }
    return <Navigate to="/panel" replace />;
}
